export const island = {
	panel: {
		combustibleClearance: 'COMBUSTIBLE_CLEARANCE',
		countertopSeam: 'COUNTERTOP_SEAM_REQUIRED',
		fridgeSpacing: 'FRIDGE_SPACING_REQUIRED',
		overhang: 'OVERHANG_LIMIT_EXCEEDED',
		spacing: 'NOT_ENOUGH_SPACE'
	},
	size: {
		height: 'HEIGHT_LIMIT_EXCEEDED',
		baseDepth: 'BASE_DEPTH_LIMIT',
		sinkDepth: 'SINK_DEPTH_LIMIT',
		sameHeight: 'SAME_HEIGHT_STACKED_STONE',
		countertopDepth: 'COUNTERTOP_DEPTH_LIMIT_EXCEEDED'
	}
};
